export const BRAND = {
    name: "Nimad Zayka Spices Pvt. Ltd.",
    shortName: "Nimad Zayka",
    since: "1990",
    tagline: "Swaad jo Nimad se aayo",
    hero: "Legacy of Purity, Powered by Women, Driven by Heritage.",
    email: "info@nimadzayka.com",
    phone: "+91 62659 96333",
    phoneRaw: "+916265996333",
    whatsapp: "916265996333",
    logo: "https://i.ibb.co/Y4byrqxw/Untitled-design.png",
    journey: "https://customer-assets.emergentagent.com/job_2311a9ad-e206-4c20-a1b4-b68b98e740de/artifacts/1lqxwjkh_Untitled%20design.png",
    founderPhoto:
        "https://customer-assets.emergentagent.com/job_spice-heritage-68/artifacts/8c3b81kp_1C1187C0-6.jpeg",
    haatBazaar:
        "https://customer-assets.emergentagent.com/job_spice-heritage-68/artifacts/9oqtmc1b_CF64513A-0.jpeg",
    papaDukan:
        "https://customer-assets.emergentagent.com/job_spice-heritage-68/artifacts/decu1qfy_IMG_2630_Original.jpeg",
    spicesMap:
        "https://customer-assets.emergentagent.com/job_spice-heritage-68/artifacts/8h0tp8vy_Gemini_Generated_Image_xsd4p8xsd4p8xsd4.png",
    addresses: {
        factory: {
            label: "Manufacturing Unit",
            city: "Rajpur, Madhya Pradesh",
            line: "Rajpur (451447), Dist. Barwani, Madhya Pradesh, India",
        },
        office: {
            label: "Marketing Office",
            city: "Indore, Madhya Pradesh",
            line: "975, Scheme No. 51, Indore, Madhya Pradesh, India",
        },
    },
    social: {
        instagram: "https://www.instagram.com/nimadzayka.in?igsh=amN1amV5MGJ1Nml4&utm_source=qr",
        facebook: "https://facebook.com",
        youtube: "https://youtube.com",
    },
};

export const HERO_SLIDES = [
    {
        key: "haat-bazaar",
        chapter: "1990 · हाट बाज़ार",
        kicker: "The Haat Bazaar Days",
        title: "जहाँ से शुरू हुआ सफ़र।",
        subtitle: "Where our journey began.",
        image:
            "https://customer-assets.emergentagent.com/job_spice-heritage-68/artifacts/9oqtmc1b_CF64513A-0.jpeg",
        cta: { label: "हमारी विरासत", to: "/about" },
    },
    {
        key: "founder",
        chapter: "संस्थापक · Mukesh Kushwah",
        kicker: "Our Founder",
        title: "पिताजी की विरासत।",
        subtitle: "Three decades of the Kushwah family promise.",
        image:
            "https://customer-assets.emergentagent.com/job_spice-heritage-68/artifacts/8c3b81kp_1C1187C0-6.jpeg",
        cta: { label: "संस्थापक से मिलें", to: "/about" },
    },
    {
        key: "rajpur-plant",
        chapter: "2023 · राजपुर, मध्य प्रदेश",
        kicker: "A modern Pvt. Ltd. powerhouse",
        title: "नीमाड़ का असली ज़ायका।",
        subtitle: "FSSAI-grade, women-powered Rajpur facility.",
        image:
            "https://images.unsplash.com/photo-1581091870627-3a3b3e43b3a0?auto=format&fit=crop&w=1920&q=80",
        cta: { label: "मसाले देखें", to: "/products" },
    },
];

export const TIMELINE = [
    {
        year: "1990",
        title: "The Haat Bazaar Days",
        text: "Mukesh Kushwah begins trading spices in the rural Haat Bazaars of the Nimad region — hand-weighed, face-to-face, one customer at a time.",
    },
    {
        year: "2005",
        title: "Our First Stone Mill",
        text: "A traditional stone mill is set up in Rajpur for authentic, low-heat grinding — the true birth of the Nimad Zayka flavour profile.",
    },
    {
        year: "2023",
        title: "Pvt. Ltd. Powerhouse",
        text: "A full-scale, hygienic manufacturing facility comes online in Rajpur. The family business formally transitions to Nimad Zayka Spices Pvt. Ltd.",
    },
    {
        year: "2025-26",
        title: "Global Brand Launch",
        text: "Official global launch of the Nimad Zayka branded product line — Standard Pouch & Premium Box ranges travel beyond Nimad for the first time.",
    },
];

export const JOURNEY_STEPS = [
    {
        title: "Handpicked from Farms",
        detail: "Sourced directly from Nimadi farmers along the Narmada valley.",
        icon: "fa-solid fa-seedling",
    },
    {
        title: "Natural Sun Drying",
        detail: "Slow sun-drying preserves colour, aroma, and nutrients.",
        icon: "fa-solid fa-sun",
    },
    {
        title: "Traditional Grinding",
        detail: "Stone-ground and small-batch milled the Nimadi way.",
        icon: "fa-solid fa-mortar-pestle",
    },
    {
        title: "Hygienically Packed",
        detail: "Sealed at our Rajpur plant with modern food-safety standards.",
        icon: "fa-solid fa-box",
    },
    {
        title: "Ready for Your Kitchen",
        detail: "Delivered to homes and restaurants across India.",
        icon: "fa-solid fa-utensils",
    },
];
